// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { deleteProductFamilies } from "./schema/delete-product-families";
import { getProductCatalog } from "./schema/get-product-catalog";
import {
  getProductVariantCatalog,
  getProductVariantCatalogCount,
  getProductVariantFieldValues,
} from "./schema/get-product-variant-catalog";
import { listManagedMerchantStores } from "./schema/list-managed-merchant-stores";
import { deleteGuidance } from "./schema/listing-optimization/delete-guidance";
import { getGuidance } from "./schema/listing-optimization/get-guidance";
import { upsertGuidance } from "./schema/listing-optimization/upsert-guidance";
import { bulkUpdateProductDetails } from "./schema/product-catalog/bulk-update-product-details";
import { streamListingFieldOptimization } from "./schema/product-catalog/stream-listing-field-optimization";
import { getProductTaxonomy } from "./schema/product-taxonomy-finder/get-product-taxonomy";
import { searchProductTaxonomy } from "./schema/product-taxonomy-finder/search-product-taxonomy";
import { getRecommendedPurchaseOrders } from "./schema/purchase-orders/get-recommended-purchase-orders";

export const groupH: {
  bulkUpdateProductDetails: typeof bulkUpdateProductDetails;
  streamListingFieldOptimization: typeof streamListingFieldOptimization;
  deleteProductFamilies: typeof deleteProductFamilies;
  getProductCatalog: typeof getProductCatalog;
  getProductVariantCatalog: typeof getProductVariantCatalog;
  getProductVariantCatalogCount: typeof getProductVariantCatalogCount;
  getProductVariantFieldValues: typeof getProductVariantFieldValues;
  listManagedMerchantStores: typeof listManagedMerchantStores;
  getProductTaxonomy: typeof getProductTaxonomy;
  searchProductTaxonomy: typeof searchProductTaxonomy;
  getRecommendedPurchaseOrders: typeof getRecommendedPurchaseOrders;
  deleteGuidance: typeof deleteGuidance;
  getGuidance: typeof getGuidance;
  upsertGuidance: typeof upsertGuidance;
} = {
  bulkUpdateProductDetails,
  streamListingFieldOptimization,
  deleteProductFamilies,
  getProductCatalog,
  getProductVariantCatalog,
  getProductVariantCatalogCount,
  getProductVariantFieldValues,
  listManagedMerchantStores,
  getProductTaxonomy,
  searchProductTaxonomy,
  getRecommendedPurchaseOrders,
  deleteGuidance,
  getGuidance,
  upsertGuidance,
};
